module.exports = __webpack_public_path__ + "static/media/LandingAboutUsImg.ebd716fa.png";